import type { ValueOf } from '../util/typeUtils';

export const TEMPLATE_RESOLVERS = {
    getAllTemplates: 'getAllTemplates',
    getDemandedDocumentsTemplate: 'getDemandedDocumentsTemplate',
    getDivisionHeaderFooterTemplate: 'getDivisionHeaderFooterTemplate',
    getDivisionMailByDivisionAndStatus: 'getDivisionMailByDivisionAndStatus',
    getFooters: 'getFooters',
    getHeaders: 'getHeaders',
    getMailHeaderFooter: 'getMailHeaderFooter',
    getMailTemplates: 'getMailTemplates',
    getOfferTemplates: 'getOfferTemplates',
    getOwnMailHeaderFooter: 'getOwnMailHeaderFooter',
    getSignature: 'getSignature',
    getSignatures: 'getSignatures',
    getStatusesWithDivisionMailTrigger: 'getStatusesWithDivisionMailTrigger',
    getSystemMailTemplates: 'getSystemMailTemplates',
    listByDivision: 'listByDivision',
    listByDivisions: 'listByDivisions',
    listDivisionHeaderFooters: 'listDivisionHeaderFooters',
} as const;

export type TEMPLATE_RESOLVER = ValueOf<typeof TEMPLATE_RESOLVERS>;
